<template>
  <div>
    <iframe-container
      :iframe-id="iframeId"
      empty-state-description="This template has no preview yet"
      :preview-content="previewContent"
    />
  </div>
</template>

<script>
import IframeContainer from '../IframeContainer'
import { mapGetters } from 'vuex'

export default {
  name: 'HistoryPreview',
  components: {
    IframeContainer
  },
  inject: ['hasPreviewBeenOpened'],
  provide () {
    return {
      isLoading: () => false
    }
  },
  props: {
    iframeId: {
      type: String,
      required: true,
      default: null
    },
    previewContent: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getLoadingStatus'
    })
  }
}
</script>
